export enum KeyboardInputEnum {
    Space = ' ',
    M = 'm',
    ArrowUp = 'arrowup',
    ArrowLeft = 'arrowleft',
    ArrowRight = 'arrowright',
    ArrowDown = 'arrowdown',
    F = 'f',
    Escape = 'escape',
}
